// Single source of truth for CardScienceHQ card services + pricing.
// Used by the homepage pricing section AND the submission form so there is
// only ONE submission system.

export const SERVICES = [
  {
    id: "clean_polish",
    name: "Clean + Polish",
    price: 25,
    blurb: "Professional surface cleaning and polish.",
    // Volume pricing applies ONLY to Clean + Polish.
    volume: [
      { upTo: 3, price: 25, label: "1–3 cards" },
      { upTo: 10, price: 20, label: "4–10 cards" },
      { upTo: Infinity, price: 15, label: "10+ cards" },
    ],
  },
  {
    id: "clean_polish_plus",
    name: "Clean + Polish +",
    price: 30,
    blurb: "Cleaning and polishing plus attention to small indentations and creases, aiming to minimize their appearance where possible.",
  },
  {
    id: "card_rehab",
    name: "Card Rehab",
    price: 50,
    blurb: "For cards requiring more extensive attention and restoration work.",
  },
  {
    id: "grading_prep",
    name: "Grading Prep",
    price: 75,
    blurb: "We evaluate whether professional grading is worth considering, then clean, polish, inspect and prepare selected cards for submission.",
  },
];

export const SERVICE_IDS = SERVICES.map((s) => s.id);

export const getService = (id) => SERVICES.find((s) => s.id === id);

// Per-card price for a service at a given card count (volume-aware).
export function pricePerCard(serviceId, qty) {
  const s = getService(serviceId);
  if (!s) return 0;
  if (s.volume) {
    for (const tier of s.volume) {
      if (qty <= tier.upTo) return tier.price;
    }
  }
  return s.price;
}

export function estimateTotal(serviceId, qty) {
  const n = Number(qty) || 0;
  return pricePerCard(serviceId, n) * n;
}
